"use strict";

module.exports = require("./NewRelicErrorProcessor");